<template>
  <BaseDialog centered contentClass="edit-tenant-website" ref="dialog" persistent :show-actions="true">
    <template slot="title">
      {{ existingWebsite ? this.$t('page.admin-tenant.website.edit') : this.$t('page.admin-tenant.website.add') }}
    </template>
    <template slot="content">
      <form @click.prevent @keydown.enter.prevent contentClass="edit-tenant-website__form">
        <div>
          <template>
            <FormLabel>{{ $t('page.admin-tenant.website.form-label') }}</FormLabel>
            <FormInput
              id="tenant-website"
              v-model="website"
              type="url"
              name="inputWebsite"
              ref="inputWebsite"
              hasGrayBackground
              :error="websiteError"
            />
          </template>
        </div>

        <div class="base-dialog__edit-tenant--actions">
          <FormButton is-outlined @click.native="cancelClick">
            {{ $t('actions.cancel') }}
          </FormButton>

          <FormButton @click.native="onSubmit" :disabled="isFormInvalid || hasNotChanged">
            {{ $t('actions.save') }}
          </FormButton>
        </div>
      </form>
    </template>
  </BaseDialog>
</template>

<script>
import FormLabel from '@/components/form/FormLabel.vue';
import BaseDialog from '@/components/base/BaseDialog.vue';
import FormButton from '@/components/form/FormButton.vue';
import FormInput from '@/components/form/FormInput.vue';
import { isValidUrl } from '@/util/url-util';

export default {
  name: 'EditTenantWebsite',
  components: {
    BaseDialog,
    FormButton,
    FormInput,
    FormLabel,
  },
  data() {
    return {
      website: this.existingWebsite,
    };
  },
  props: {
    existingWebsite: {
      type: String,
      required: false,
    },
  },
  computed: {
    hasNotChanged() {
      return this.website === this.existingWebsite;
    },
    isFormInvalid() {
      return !this.website || !isValidUrl(this.website);
    },
    websiteError() {
      return !isValidUrl(this.website) ? this.$t('page.admin-tenant.website.url-error') : '';
    },
  },
  methods: {
    openDialog() {
      this.$refs.dialog.openModal();

      this.$nextTick(() => {
        const refInput = this.$refs.inputWebsite.$el.querySelector('input');
        if (refInput) {
          this.$nextTick(() => {
            refInput.focus();
          });
        }
      });
    },
    closeDialog() {
      this.$refs.dialog.isModalOpen = false;
    },
    cancelClick() {
      this.closeDialog();
    },
    onSubmit() {
      this.$emit('update-website', this.website);
      this.closeDialog();
    },
  },
  watch: {
    existingWebsite() {
      this.website = this.existingWebsite;
    },
  },
};
</script>

<style lang="scss">
.base-dialog__edit-tenant-website {
  height: auto;
  width: 550px;
  position: relative;

  &.description-mode {
    width: 800px;
  }
  .base-dialog__content {
    padding: 32px;
    font-size: 18px;
    background: $color-white !important;
  }

  &--actions {
    margin-top: 32px;
    justify-content: flex-end;
    display: flex;
    gap: 12px;
  }

  .form-input {
    padding: 4px 0 24px 0;
  }
}
</style>
